import axios from "axios";
import { handleResponse, handleError } from "../services/serviceUtil";
import ApiService from "../auth/ApiService";

const apiEndpoint = ApiService.API_URL;
const resourceUrl = apiEndpoint + "/secured/user";

const UserAPI = {
  userData: {
    data: []
  },

  all: async function() {
    let data = await new ApiService().callApi(`${resourceUrl}/summary/all`, "get");
    this.userData.data = data.data;
    return this.userData;
  },
  save: async function(user) {
    let data = await new ApiService().callApi(`${resourceUrl}`, "post", user);
    return data.data;
  },
  getUser: async function(uniqueId) {
    return new ApiService()
      .callApi(`${resourceUrl}/${uniqueId}`, "get")
      .then(handleResponse)
      .catch(handleError);
  },
  getProfile: async function(uniqueId) {
    return new ApiService()
      .callApi(`${resourceUrl}/profile`, "get")
      .then(handleResponse)
      .catch(handleError);
  },
  updateUser: function(user) {
    return new ApiService()
      .callApi(`${resourceUrl}`, "put", user)
      .then(handleResponse)
      .catch(handleError);
  },
  updateProfile: function(user) {
    return new ApiService()
      .callApi(`${resourceUrl}/profile`, "put", user)
      .then(handleResponse)
      .catch(handleError);
  },
  deleteUser: function(uniqueId) {
    return new ApiService()
      .callApi(`${resourceUrl}/${uniqueId}`, "delete")
      .then(handleResponse)
      .catch(handleError);
  },
  isFirstUser: function(uniqueId) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Basic cG9ydGFsdXNlcjpjbXBwYXNzd29yZA=="
    };

    return axios
      .get(`${apiEndpoint}/public/firstuser`, {
        params: {
          uniqueId: uniqueId
        },
        headers
      })
      .then(handleResponse)
      .catch(handleError);
  },
  allSummarizedUsers: async function(param) {
    let data;
    if (!param)
      data = await new ApiService().callApi(`${resourceUrl}/summary/all`, "get");
    else
      data = await new ApiService().callApi(`${resourceUrl}/summary/all?caseLock=${param}`, "get");

    this.userData.data = data.data;
    return this.userData;
   },
  getUsersByWorkflowId: async function(workflowId) {
    let data = await new ApiService().callApi(`${resourceUrl}/workflow/${workflowId}`, "get");
    this.userData.data = data.data;
    return this.userData;
  },
  getAuthConfig: function(loginEmail) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Basic cG9ydGFsdXNlcjpjbXBwYXNzd29yZA=="
    };
  
    return axios
      .get(`${apiEndpoint}/public/auth-profile-configs`, {
        params: {
          email: loginEmail
        },
        headers
      })
      .then(handleResponse)
      .catch(handleError);
  },
  getUsersByWorkflowIdAndCaseStateActionId: async function(workflowId,CaseStateActionId,uniqueId) {  
    let data = await new ApiService().callApi(`${resourceUrl}/workflow/${workflowId}/${CaseStateActionId}/${uniqueId}`, "get");
    if(data && data.data) {
      this.userData.data = data.data;
    } 
    return this.userData;
  }
};

export default UserAPI;
